export class Service {
    constructor(service) {
        this.id          = service.id;
        this.name        = service.name;
        this.create_at   = service.create_at;
        this.type        = service.type;
        this.group_id    = service.group_id;
        this.status      = service.status;
        this.priority    = service.priority;
        this.category_id = service.category_id;
        this.onwer_id    = service.onwer_id;
        this.price       = service.price;
        this.note        = service.note;
        this.point_bonus = service.point_bonus;
        this.duration    = service.duration;
        this.buffer_time = service.buffer_time;
        this.supply_share = service.supply_share;
    }
}
